var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.714,
    d: "M15.35 22.285a5.47 5.47 0 0 0 6.858-.754l.771-.754a1.85 1.85 0 0 0 0-2.589l-3.274-3.24a1.835 1.835 0 0 0-2.572 0 1.85 1.85 0 0 1-2.588 0L9.402 9.806a1.817 1.817 0 0 1 0-2.589 1.834 1.834 0 0 0 0-2.571L6.145 1.388a1.85 1.85 0 0 0-2.589 0l-.754.772a5.47 5.47 0 0 0-.754 6.857A49.6 49.6 0 0 0 15.35 22.285"
  })));
};
export default SvgPhone;